import Store from "@/store/index.js";
import axios from 'axios';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
    async ObtenerPreguntas(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/ObtenerPreguntasChecklistEjec`, datos);
        return response.data;
    },
    async ValidarPreg(reporte, veid) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("veid", veid);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/CheckListEjecutivoValMovimientos`, datos);
        return response.data;
    },
    async ValidacionNA(respuestas) {
        var datos = new FormData();
        datos.append("respuestasNA", respuestas);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/ValidacionNA`, datos);
        return response.data;
    },
    async ValidarEFirma(efirma) {
        var formData = new FormData();
        formData.append("efirma", efirma);
        let response = await axios.post(`${domain.domainNameForApi}Movimientos/ValidarEFirma`, formData);
        return response.data;
    },
    async GuardarValidacionEjec(reporte, resp, estatus, tipo, firma) {
        var formData = new FormData();
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        formData.append("resp", resp);
        formData.append("estatus", estatus);
        formData.append("tipo", tipo);
        formData.append("firma", firma);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/GuardarValidacionEjec`, formData);
        return response.data;
    },
    async GuardarAutorizarConclucion(reporte, resp, obs, fechaMovto) {
        var formData = new FormData();
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        formData.append("aiclave", reporte.aiclave);
        formData.append("resp", resp);
        formData.append("obs", obs);
        formData.append("fechaMovto", fechaMovto);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/GuardarAutorizarConclucion`, formData);
        return response.data;
    },
    async ValidarConclusion(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        formData.append("uslogin", MetodosGenerales.ObtenerUserName());
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/ValidarConclusion`, formData);
        return response.data[0];
    },
    async CeclavesConclusion(vm, tipo) {
        var datos = new FormData();
        datos.append("aiclave", vm.reporte.aiclave);
        datos.append("nrreporte", vm.reporte.nrreporte);
        datos.append("svindice", vm.reporte.svindice);
        datos.append("tipo", tipo);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Conclusion/CeclavesConclusion`, datos);
        vm.Conclusiones.opcionesConclusiones = response.data;
    },
    async GuardarConclusion(reporte, ceclave, fechaMovto, obs) {
        var formData = new FormData();
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        formData.append("aiclave", reporte.aiclave);
        formData.append("ceclave", ceclave);
        formData.append("fechaMovto", fechaMovto);
        formData.append("obs", obs);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/GuardarConclusion`, formData);
        return response.data;
    },
    async ValidarAutorizarConclusion(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        let response = await axios.post(`${domain.domainNameForApi}Conclusion/ValidarAutorizarConclusion`, formData);
        return response.data;
    }
}